// Arma un registro de auditoría "optimista" tras un guardado exitoso, para secciones cuyo
// endpoint no regresa el objeto actualizado — evita esperar a recargar toda la pantalla
// para reflejar quién hizo el último cambio. accion siempre "M" (edición), nunca alta aquí.
export const construirAuditoriaLocal = (empleado) => ({
  ultimousuario: empleado || "",
  ultima_fecha: new Date().toISOString(),
  accion: "M",
});
